import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "../mock";

export const StructuredData = () => {
  const imageUrl = typeof SITE.logoUrl === "string" && SITE.logoUrl.startsWith("http")
    ? SITE.logoUrl
    : `https://www.zdravepacky.cz${SITE.logoUrl}`;

  const schema = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "VeterinaryCare"],
    "name": SITE.name,
    "image": imageUrl,
    "telephone": SITE.contacts.phone,
    "email": SITE.contacts.email,
    "url": "https://www.zdravepacky.cz",
    "priceRange": "200 Kč - 1000 Kč",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Nový Bohumín",
      "postalCode": "735 81",
      "addressCountry": "CZ"
    },
    "sameAs": [
      SITE.contacts.facebook,
      SITE.contacts.instagram,
      SITE.bookingUrl
    ].filter(Boolean)
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};